import { ActionTypes } from 'Actions/actions';

export const incrementAPICount = () => ({
	type: ActionTypes.INCREMENT_API_COUNT,
});
export const decrementAPICount = () => ({
	type: ActionTypes.DECREMENT_API_COUNT,
});
